import { customAlphabet } from 'nanoid';

const generateNanoId = customAlphabet(
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
);

export default generateNanoId;
